import { useNativeNotificationListener } from '@ztechapps/common.hook'

// Mounted once in an admin's private layout; renders nothing.
export const NativeNotificationListener = () => {
  useNativeNotificationListener()
  return null
}
